class CurrencyPicker extends HTMLElement {
  constructor() {
    super();

    const localCurrency = window.localStorage.getItem("activeCurrency");
    const localizationForm = document.querySelector('localization-form');

    this.currency = localCurrency || window.default_currency;

    this.querySelectorAll("button[value]").forEach((element) => {
      element.addEventListener("click", () => {
        this.setCurrency(element.value);
        localizationForm.querySelector('[name=country_code]').value = element.dataset.country;
        localizationForm.querySelector('form').submit();
      });
    });

    window.addEventListener("currency_changed", (event) => {
      this.currency = event.detail.currency;
      this.render();
    });

    this.render();
  }

  setCurrency(currency) {
    window.localStorage.setItem("activeCurrency", currency);
    window.dispatchEvent(
      new CustomEvent("currency_changed", {
        detail: {
          currency,
        },
      })
    );
  }

  render() {
    // this.querySelector(".active-currency").innerHTML = this.querySelector(
    //   `[value='${this.currency}']`
    // ).innerHTML;
  }
}

customElements.define("currency-picker", CurrencyPicker);
